import { AxiosError } from 'axios';
import adminApi from '../../api/adminApi';
import useStore from '../../store/store';

export interface AddReportParams {
    kitId: number;
    releaseDate: Date;
    report?: File;
}

const AddReport = async (params: AddReportParams) => {
    const { setFormError, setIsLoading } = useStore.getState();
    setIsLoading(true);

    try {
        const formData = new FormData();
        formData.append('kitId', params.kitId.toString());
        formData.append('releaseDate', params.releaseDate.toISOString());
        if (params.report) {
            formData.append('report', params.report);
        }

        const response = await adminApi.post('/report/add', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        const { success, errCode } = response.data;
        if (success) {
            setFormError('');
        } else if (errCode) {
            setFormError(errCode);
        } else {
            setFormError('other');
        }
    } catch (e: unknown) {
        if (e instanceof AxiosError) {
            console.error(e.response?.data);
            setFormError('');
            setTimeout(() => setFormError(e.code ?? 'other'), 0);
        } else {
            setFormError('');
            setTimeout(() => setFormError('other'), 0);
        }
    } finally {
        setIsLoading(false);
    }
};

export default AddReport;
